import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import { api } from '@/utils/api';
import commonActions from './common.actions';
import { CommonActionTypes } from './common.types';
import { AWS_GATOR_SOLUTIONS_URL, config } from '@/config';
import { isBRServer } from '@/utils/Validators/validation';
import logger from '@/utils/logger';
import { getCache, setCache } from '@/utils/cacheControl';
import { CACHE_KEYS } from '@/enums/cache/cache.enum';


const { WHMCS_URL } = config;

function* requestSupportDepartmentStatus() {
  const cacheKey = CACHE_KEYS.SUPPORT_DEPARTMENT_STATUS;
  const cachedData = getCache(cacheKey);

  if (cachedData) {
    // Bypass state update and directly use cached data
    return;
  }

  const { token, jwt: jwtToken } = yield select(state => state.auth);
  const brand = isBRServer ? 'br' : 'es';

  const request = {
    url: `${WHMCS_URL}/api/v3/support/departments`,
    headers: {
      Authorization: `Bearer ${token}`,
      'x-service-token': jwtToken,
      brand,
    },
  };

  yield put(commonActions.serverTime.setLoading(true));

  try {
    const response = yield call(api.whmcs.get, request);
    const serverTimeInfos = response && response.data;

    // Cache the response for 3 minutes
    setCache(cacheKey, serverTimeInfos, 180000);

    yield put(commonActions.serverTime.set(serverTimeInfos));
  } catch (requestError) {
    const error = { ...requestError, userRequestData: request };

    if (error.response && error.response.status !== 401) {
      logger.error('Error sagas common - method requestServerTime', error);
    }
  }

  yield put(commonActions.serverTime.setLoading(false));
}

function* requestPdfUrlByType({ payload }) {
  const { token } = yield select(state => state.auth);
  const { id } = yield select(state => state.summary);
  const { pdfUrl, urlType } = payload;
  const brand = isBRServer ? 'br' : 'es';

  const request = {
    url: `${AWS_GATOR_SOLUTIONS_URL}/pdf/url`,
    headers: {
      Authorization: `Bearer ${token}`,
      'x-region': brand,
    },
    data: {
      file_name: `${id}/${pdfUrl}`,
      action: urlType,
    },
  };

  try {
    const response = yield call(api.external.post, request);
    const pdfUrl = response && response.data;

    yield put(commonActions.pdf.set(pdfUrl));
  } catch (requestError) {
    yield put(commonActions.pdf.set(null));
    const error = { ...requestError, userRequestData: request };

    if (error.response && error.response.status !== 401) {
      logger.error('Error sagas common - method requestPdfUrlByType', error);
    }
  }
}

function* sagas() {
  yield takeLatest(CommonActionTypes.REQUEST_SERVER_TIME, requestSupportDepartmentStatus);
  yield takeLatest(CommonActionTypes.REQUEST_PDF_URL_BY_TYPE, requestPdfUrlByType);
}

export default sagas;
